import { Module } from 'wrapper6'

const $ = jQuery

export default class MendelayModal extends Module {
  ready (app) {
    this.modalInner = document.querySelector('.modal[data-id="mendelay-modal"] .modal-inner-content')
    this.mendelayCards = '.mtt-mendelay-paper'
    this.mendelayArhiveCards = '.mtt-mendelay-archive__wrapper > li'
    this.mendelayReadMore = '.mtt-read-more__mendelay'

    $(document).on('click', this.mendelayCards, (e) => {
      const event = $(e.currentTarget)
      this.addContentToModal(
        event.attr('data-title'),
        event.find('.mtt-mendelay-paper__abstract').html(),
        event.find('.mtt-mendelay-paper__modal-info').html(),
        event.find('.mtt-read-more__mendelay-doi').html(),
        event.find('.mtt-read-more__mendelay-urls').html(),
      )
    })

    $(document).on('click', this.mendelayArhiveCards, (e) => {
      const event = $(e.currentTarget)
      this.addContentToModal(
        event.find('h3').html(),
        event.find('.abstract-text').html(),
        event.find('.info').html(),
        event.find('.mtt-read-more__mendelay-doi').html(),
        event.find('.mtt-read-more__mendelay-urls').html(),
      )
    })

    $(document).on('click', this.mendelayReadMore, (e) => {
      const event = $(e.currentTarget)
      this.addContentToModal(
        event.attr('data-title'),
        event.find('.mtt-read-more__mendelay-abstract').html(),
        event.find('.mtt-read-more__mendelay-modal-info').html(),
        event.find('.mtt-read-more__mendelay-doi').html(),
        event.find('.mtt-read-more__mendelay-urls').html(),

      )
    })
  }

  addContentToModal (title, abstract, info,doi,urls) {
    this.modalInner.innerHTML = ''
    this.modalInner.innerHTML += '<h3 class="modal-title"> ' + title + ' </h3>'
    this.modalInner.innerHTML += '<div class="modal-label"> <p> ' + info + ' </p> </div>'
    this.modalInner.innerHTML += '<div class="modal-text"> <p> ' + abstract + ' </p> </div>'
    this.modalInner.innerHTML += '<div class="modal-text"> <p> ' + doi + ' </p> </div>'
    this.modalInner.innerHTML += '<div class="modal-text"> <p> ' + urls + ' </p> </div>'
  }
}
